/* HD Scroll Hero – flüssiges Scroll-Video.
   Modus 1 (modern, Chrome/Edge/Safari): komplettes Video wird geladen, selbst entpackt (WebCodecs)
   und auf eine Zeichenfläche gezeichnet – mit Überblendung zwischen zwei Bildern.
   Modus 2 (Rückfall): normales <video> mit Sprung auf das passende Bild. */
(function () {
  if (window.__HD_SCROLL_VIDEO_FINAL__) return;
  window.__HD_SCROLL_VIDEO_FINAL__ = true;

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  /* ---------- MP4 entpacken (nur das Nötige für H.264) ---------- */
  function demuxMp4(buf) {
    var dv = new DataView(buf), u8 = new Uint8Array(buf);
    function u32(o) { return dv.getUint32(o); }
    function type(o) { return String.fromCharCode(u8[o + 4], u8[o + 5], u8[o + 6], u8[o + 7]); }
    function boxes(start, end) {
      var out = [], o = start;
      while (o + 8 <= end) {
        var size = u32(o), t = type(o), hdr = 8;
        if (size === 1) { size = dv.getUint32(o + 8) * 4294967296 + dv.getUint32(o + 12); hdr = 16; }
        else if (size === 0) size = end - o;
        if (size < hdr) break;
        out.push({ t: t, s: o + hdr, e: o + size });
        o += size;
      }
      return out;
    }
    function find(list, t) { for (var i = 0; i < list.length; i++) if (list[i].t === t) return list[i]; return null; }
    function kids(b) { return boxes(b.s, b.e); }
    var moov = find(boxes(0, buf.byteLength), 'moov');
    var traks = kids(moov).filter(function (b) { return b.t === 'trak'; });
    for (var ti = 0; ti < traks.length; ti++) {
      var mdia = find(kids(traks[ti]), 'mdia'); if (!mdia) continue;
      var hdlr = find(kids(mdia), 'hdlr');
      if (!hdlr || String.fromCharCode(u8[hdlr.s + 8], u8[hdlr.s + 9], u8[hdlr.s + 10], u8[hdlr.s + 11]) !== 'vide') continue;
      var mdhd = find(kids(mdia), 'mdhd');
      var timescale = u8[mdhd.s] === 1 ? u32(mdhd.s + 20) : u32(mdhd.s + 12);
      var sb = kids(find(kids(find(kids(mdia), 'minf')), 'stbl'));
      var stsd = find(sb, 'stsd');
      var entry = boxes(stsd.s + 8, stsd.e)[0];
      var width = dv.getUint16(entry.s + 24), height = dv.getUint16(entry.s + 26);
      var avcC = find(boxes(entry.s + 78, entry.e), 'avcC');
      var desc = u8.slice(avcC.s, avcC.e);
      var hx = function (n) { return ('0' + n.toString(16)).slice(-2); };
      var stsz = find(sb, 'stsz'), fixed = u32(stsz.s + 4), count = u32(stsz.s + 8), sizes = [], i, n;
      for (i = 0; i < count; i++) sizes.push(fixed || u32(stsz.s + 12 + i * 4));
      var stco = find(sb, 'stco'), co64 = find(sb, 'co64'), offsets = [];
      if (stco) { n = u32(stco.s + 4); for (i = 0; i < n; i++) offsets.push(u32(stco.s + 8 + i * 4)); }
      else { n = u32(co64.s + 4); for (i = 0; i < n; i++) offsets.push(dv.getUint32(co64.s + 8 + i * 8) * 4294967296 + dv.getUint32(co64.s + 12 + i * 8)); }
      var stsc = find(sb, 'stsc'), sn = u32(stsc.s + 4), runs = [];
      for (i = 0; i < sn; i++) runs.push([u32(stsc.s + 8 + i * 12), u32(stsc.s + 12 + i * 12)]);
      var stts = find(sb, 'stts'), delta = u32(stts.s + 12);
      /* Ankerbilder (Keyframes); fehlt die Liste, ist jedes Bild ein Ankerbild */
      var stss = find(sb, 'stss'), keys = [];
      if (stss) { n = u32(stss.s + 4); for (i = 0; i < n; i++) keys.push(u32(stss.s + 8 + i * 4) - 1); }
      else for (i = 0; i < count; i++) keys.push(i);
      var samples = [], s = 0;
      for (var c = 0; c < offsets.length; c++) {
        var per = runs[0][1];
        for (var r = 0; r < runs.length; r++) if (c + 1 >= runs[r][0]) per = runs[r][1];
        var off = offsets[c];
        for (var k = 0; k < per && s < count; k++, s++) { samples.push([off, sizes[s]]); off += sizes[s]; }
      }
      return { codec: 'avc1.' + hx(desc[1]) + hx(desc[2]) + hx(desc[3]), description: desc, width: width, height: height, fps: timescale / delta, samples: samples, keys: keys, data: u8 };
    }
    throw new Error('keine Videospur');
  }

  function init(root) {
    if (!root || root.__hdVideoFinal) return;
    root.__hdVideoFinal = true;

    var video = root.querySelector('[data-hd-final-video]');
    var poster = root.querySelector('[data-hd-final-poster]');
    var media = root.querySelector('.hd-scroll-final__media');
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-hd-final-layer]'));
    var scrim = root.querySelector('[data-hd-final-scrim]');
    if (!video) return;

    /* Nachlauf als gedämpfte Feder: das Tempo ändert sich nie sprunghaft – beim Aufhören rollt das Video weich aus */
    var OMEGA = 8, vel = 0;
    var fps = Number(root.dataset.hdFps) || 24, duration = 30;
    var targetProgress = 0, displayProgress = 0, lastProgress = -1;
    var lastScrollAt = performance.now(), lastTick = performance.now();
    var raf = 0, destroyed = false, ready = false;
    var lastSeekFrame = -1, pendingFrame = -1;
    var cv = null; /* Zeichenflächen-Modus */
    var loadingFull = false; /* solange das ganze Video lädt: Bild ruhig halten statt ruckelnd springen */
    var bar = null;

    var staticMode = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Handy: eigenes Hochkant-Video (kleiner, passt genau aufs Display) */
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var stageEl = root.querySelector('.hd-scroll-final__stage');
    if (mobile && root.dataset.mobileSrc) {
      var srcEl = video.querySelector('source');
      if (srcEl) srcEl.src = root.dataset.mobileSrc; else video.src = root.dataset.mobileSrc;
    }

    function rawProgress() {
      var rect = root.getBoundingClientRect();
      /* Höhe der Bühne statt Fensterhöhe: am Handy ändert sich die Fensterhöhe beim Ein-/Ausblenden der Adressleiste */
      var travel = Math.max(1, root.offsetHeight - (stageEl ? stageEl.offsetHeight : window.innerHeight));
      return clamp(-rect.top / travel, 0, 1);
    }

    function layerOpacity(p, start, end) {
      if (p < start || p > end) return 0;
      var span = Math.max(0.001, end - start);
      var fade = Math.min(0.045, span * 0.28);
      if (start > 0 && p < start + fade) return (p - start) / fade;
      if (end >= 0.999) return 1;
      if (p > end - fade) return (end - p) / fade;
      return 1;
    }

    function updateUi(p) {
      for (var i = 0; i < layers.length; i++) {
        var el = layers[i];
        var opacity = clamp(layerOpacity(p, Number(el.dataset.start), Number(el.dataset.end)), 0, 1);
        el.style.opacity = opacity.toFixed(3);
        el.style.transform = 'translate3d(0,' + ((1 - opacity) * 14).toFixed(1) + 'px,0)';
        el.classList.toggle('is-visible', opacity > 0.05);
      }
      if (scrim) scrim.style.opacity = (p < 0.86 ? 1 : clamp((0.97 - p) / 0.11, 0, 1)).toFixed(3);
      root.classList.toggle('is-scrolled', p > 0.025);
    }

    /* ---------- Modus 2: normales Video (bis Modus 1 bereit ist) ---------- */
    function lastFrame() { return Math.max(0, Math.floor(duration * fps) - 1); }
    function applyFrame(f) {
      lastSeekFrame = f;
      try { video.currentTime = Math.min(duration - 0.001, (f + 0.5) / fps); } catch (e) {}
    }
    function seekVideo(p, force) {
      if (!ready || loadingFull) return;
      var f = Math.round(clamp(p, 0, 1) * lastFrame());
      if (!force && f === lastSeekFrame) return;
      if (video.seeking && !force) { pendingFrame = f; return; }
      pendingFrame = -1; applyFrame(f);
    }
    function onSeeked() {
      if (pendingFrame >= 0 && pendingFrame !== lastSeekFrame) { var f = pendingFrame; pendingFrame = -1; applyFrame(f); }
      else pendingFrame = -1;
    }

    /* ---------- Modus 1: eigener Decoder + Zeichenfläche ---------- */
    function startCanvasMode(buf) {
      var mv = demuxMp4(buf);
      var N = mv.samples.length, US = 1e6 / mv.fps, KEYS = mv.keys;
      fps = mv.fps; duration = N / mv.fps;
      root.__hdFrames = N; root.__hdFps = mv.fps; root.__hdDuration = duration;
      var GAP = Math.max(12, Math.round(mv.fps * 0.5)); /* größte Lücke, über die noch überblendet wird */
      var canvas = document.createElement('canvas');
      canvas.className = 'hd-scroll-final__canvas';
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:2;opacity:0;transition:opacity .25s;pointer-events:none';
      /* Bilder liegen als Texturen direkt auf der Grafikkarte – das Hochladen ist etwa doppelt so schnell
         wie eine Kopie als Einzelbild, die Überblendung macht ein kleiner Shader */
      var glOpts = { alpha: false, antialias: false, depth: false, stencil: false, premultipliedAlpha: false, preserveDrawingBuffer: false, powerPreference: 'high-performance' };
      var gl = canvas.getContext('webgl2', glOpts) || canvas.getContext('webgl', glOpts);
      if (!gl) throw new Error('kein WebGL');
      function shader(type, src) { var sh = gl.createShader(type); gl.shaderSource(sh, src); gl.compileShader(sh); return sh; }
      var prog = gl.createProgram();
      gl.attachShader(prog, shader(gl.VERTEX_SHADER, 'attribute vec2 p;varying vec2 v;uniform vec2 s;void main(){v=vec2(.5+p.x*.5*s.x,.5-p.y*.5*s.y);gl_Position=vec4(p,0.,1.);}'));
      gl.attachShader(prog, shader(gl.FRAGMENT_SHADER, 'precision mediump float;varying vec2 v;uniform sampler2D a;uniform sampler2D b;uniform float w;void main(){gl_FragColor=mix(texture2D(a,v),texture2D(b,v),w);}'));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error('Shader');
      gl.useProgram(prog);
      var quad = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, quad);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var aP = gl.getAttribLocation(prog, 'p');
      gl.enableVertexAttribArray(aP);
      gl.vertexAttribPointer(aP, 2, gl.FLOAT, false, 0, 0);
      gl.uniform1i(gl.getUniformLocation(prog, 'a'), 0);
      gl.uniform1i(gl.getUniformLocation(prog, 'b'), 1);
      var uS = gl.getUniformLocation(prog, 's'), uW = gl.getUniformLocation(prog, 'w');
      var freeTex = [];
      function upload(idx, frame) {
        var t = freeTex.pop();
        if (!t) {
          t = gl.createTexture();
          gl.bindTexture(gl.TEXTURE_2D, t);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        } else gl.bindTexture(gl.TEXTURE_2D, t);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, frame);
        cache.set(idx, t);
      }
      function draw(ta, tb, w) {
        gl.viewport(0, 0, canvas.width, canvas.height);
        var ca = canvas.width / Math.max(1, canvas.height), va = mv.width / mv.height;
        gl.uniform2f(uS, ca > va ? 1 : ca / va, ca > va ? va / ca : 1); /* wie object-fit: cover */
        gl.uniform1f(uW, w);
        gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, ta);
        gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, tb || ta);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      }
      canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); broken = true; fallbackToVideo(); });
      /* cache: Bildnummer -> Textur; queued: Bildgruppen (ab Ankerbild) im Decoder */
      var cache = new Map(), queued = new Map();
      var pendingChunks = 0, flushing = false, broken = false, drawn = false;
      var MAX_CACHE = mobile ? 30 : 42, BEHIND = 6, drainTimer = 0, lastOut = performance.now();
      var keepLo = 0, keepHi = 0;
      /* Entpacken + Hochladen schafft ~150 Bilder pro Sekunde. Bei schnellem Scrollen wird nur
         jedes n-te Bild hochgeladen (dazwischen wird überblendet), beim langsamen Scrollen
         und Ausrollen jedes einzelne Bild */
      var CONV_RATE = 75;
      function stride() { return Math.max(1, Math.min(4, Math.ceil(speed / CONV_RATE))); }
      function wanted(f, st) { return st === 1 || f % st === 0 || f === N - 1; }
      var speed = 0, lastSetAt = performance.now(), lastSetFp = 0, settleT = 0; /* Bilder pro Sekunde */

      /* Index der Bildgruppe (Ankerbild davor) für ein Bild */
      function gopIdx(f) {
        var lo = 0, hi = KEYS.length - 1;
        while (lo < hi) { var m = (lo + hi + 1) >> 1; if (KEYS[m] <= f) lo = m; else hi = m - 1; }
        return lo;
      }
      function gopEnd(gi) { return (gi + 1 < KEYS.length ? KEYS[gi + 1] : N) - 1; }
      /* Welche Bilder behalten werden: ein Stück voraus in Scrollrichtung, wenige dahinter */
      function updateKeep() {
        var fp = cv.fp, ahead = Math.max(14, Math.min(24, Math.round(speed * 0.3)));
        if (cv.dir > 0) { keepLo = Math.floor(fp) - BEHIND; keepHi = Math.ceil(fp) + ahead; }
        else { keepLo = Math.floor(fp) - ahead; keepHi = Math.ceil(fp) + BEHIND; }
        keepLo = Math.max(0, keepLo); keepHi = Math.min(N - 1, keepHi);
      }

      var decoder = new VideoDecoder({
        output: function (frame) {
          lastOut = performance.now();
          pendingChunks = Math.max(0, pendingChunks - 1);
          var idx = Math.round(frame.timestamp / US);
          var g = KEYS[gopIdx(idx)];
          if (queued.has(g)) { var left = queued.get(g) - 1; if (left <= 0) queued.delete(g); else queued.set(g, left); }
          /* Bilder einer bestellten Gruppe behalten, auch wenn sie etwas über den Vorrat hinausgehen (spart erneutes Entpacken) */
          var slack = cv && cv.dir > 0 ? [2, 14] : [14, 2];
          if (!cv || idx < keepLo - slack[0] || idx > keepHi + slack[1] || cache.has(idx) || !wanted(idx, stride())) { frame.close(); if (cv) kick(); return; }
          try { upload(idx, frame); } catch (e) { frame.close(); broken = true; fallbackToVideo(); return; }
          frame.close();
          evict();
          kick();
        },
        error: function () { broken = true; fallbackToVideo(); }
      });
      var config = { codec: mv.codec, description: mv.description, codedWidth: mv.width, codedHeight: mv.height, optimizeForLatency: true };

      function evict() {
        if (cache.size <= MAX_CACHE) return;
        var fp = cv.fp;
        function score(k) { var d = (k - fp) * cv.dir; return d < -BEHIND ? 100000 - d : Math.abs(d); } /* zuerst weit Zurückliegendes verwerfen */
        var keys = Array.from(cache.keys()).sort(function (x, y) { return score(y) - score(x); });
        while (cache.size > MAX_CACHE) { var k = keys.shift(); freeTex.push(cache.get(k)); cache.delete(k); }
      }
      /* Puffer nur leeren, wenn der Decoder hängen bleibt (sonst laufen die Bilder ohne Pause durch) */
      function scheduleDrain() {
        if (drainTimer) return;
        drainTimer = setTimeout(function () {
          drainTimer = 0;
          if (!pendingChunks || flushing || broken) return;
          if (performance.now() - lastOut < 40) { scheduleDrain(); return; }
          flushing = true;
          decoder.flush().then(function () { flushing = false; pendingChunks = 0; queued.clear(); kick(); }, function () { flushing = false; });
        }, 45);
      }
      /* Eine Bildgruppe ab ihrem Ankerbild entpacken (nur wenn darin noch benötigte Bilder fehlen).
         Rückgabe false = Decoder gerade voll, später erneut versuchen */
      function queueGop(gi) {
        var start = KEYS[gi], end = gopEnd(gi);
        if (queued.has(start)) return true;
        var from = Math.max(start, keepLo), to = Math.min(end, keepHi), need = false, st = stride();
        for (var f = from; f <= to; f++) if (!cache.has(f) && wanted(f, st)) { need = true; break; }
        if (!need) return true;
        if (broken || flushing || pendingChunks > 24 || decoder.decodeQueueSize > 30) return false;
        var last = Math.min(end, keepHi + 30); /* sehr lange Gruppen nicht komplett entpacken */
        if (last < start) last = start;
        for (f = start; f <= last; f++) {
          var smp = mv.samples[f];
          decoder.decode(new EncodedVideoChunk({ type: f === start ? 'key' : 'delta', timestamp: Math.round(f * US), data: mv.data.subarray(smp[0], smp[0] + smp[1]) }));
        }
        queued.set(start, last - start + 1);
        pendingChunks += last - start + 1;
        scheduleDrain();
        return true;
      }
      function resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = Math.min(Math.round(media.clientWidth * dpr), mv.width), h = Math.round(w * media.clientHeight / Math.max(1, media.clientWidth));
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; cv.dirty = true; }
      }
      function nearest(fp) {
        var best = null, bd = 1e9;
        cache.forEach(function (f, k) { var d = Math.abs(k - fp); if (d < bd) { bd = d; best = k; } });
        return best;
      }
      /* nächstes vorhandenes Bild unter- und oberhalb der Position */
      function around(fp) {
        var lo = null, hi = null;
        cache.forEach(function (f, k) {
          if (k <= fp && (lo === null || k > lo)) lo = k;
          if (k >= fp && (hi === null || k < hi)) hi = k;
        });
        return [lo, hi];
      }
      function render() {
        var fp = cv.fp, a = Math.floor(fp), b = Math.min(N - 1, a + 1), w = fp - a;
        var fa = cache.get(a), fb = cache.get(b), lo = a, hi = b, mode;
        if (fa && fb) mode = 'x';
        else {
          /* exaktes Paar fehlt (sehr schnelles Scrollen): zwischen den zwei nächsten Bildern überblenden */
          var r = around(fp); lo = r[0]; hi = r[1];
          if (lo !== null && hi !== null && hi - lo <= GAP) { fa = cache.get(lo); fb = cache.get(hi); w = hi > lo ? (fp - lo) / (hi - lo) : 0; mode = 'g'; }
          else { var k = nearest(fp); if (k === null) return; fa = cache.get(k); fb = null; lo = k; mode = 'n'; }
        }
        var key = mode + lo + ':' + hi + ':' + (fb ? w.toFixed(3) : '');
        if (key === cv.lastKey && !cv.dirty) return;
        cv.lastKey = key; cv.dirty = false;
        draw(fa, fb, fb && fb !== fa ? w : 0);
        if (!drawn) {
          drawn = true;
          canvas.style.opacity = '1';
          root.classList.add('has-video-frame');
          if (poster) poster.style.opacity = '0';
          root.dataset.hdStatus = 'canvas';
          loadingFull = false;
          if (bar) { bar.style.opacity = '0'; setTimeout(function () { if (bar && bar.parentNode) bar.parentNode.removeChild(bar); }, 600); }
          setTimeout(function () { try { video.pause(); video.style.visibility = 'hidden'; } catch (e) {} }, 300);
        }
      }
      /* Hängt der Decoder hinterher und arbeitet nur noch an Bildern, die schon vorbei sind: verwerfen */
      function dropStale() {
        if (!queued.size || flushing) return;
        var stale = true;
        queued.forEach(function (cnt, start) { var end = gopEnd(gopIdx(start)); if (cv.dir > 0 ? end >= keepLo : start <= keepHi) stale = false; });
        if (!stale) return;
        try { decoder.reset(); decoder.configure(config); } catch (e) { return; }
        queued.clear(); pendingChunks = 0; resets++;
      }
      var resets = 0;
      function kick() {
        if (!cv || broken) return;
        updateKeep();
        dropStale();
        var a = Math.floor(cv.fp), dir = cv.dir;
        /* Reihenfolge: aktuelle Gruppe(n), dann voraus in Scrollrichtung, zuletzt dahinter */
        var order = [gopIdx(a), gopIdx(Math.min(N - 1, a + 1))];
        var gi = gopIdx(a), gLast = gopIdx(dir > 0 ? keepHi : keepLo);
        while (gi !== gLast) { gi += dir; order.push(gi); }
        order.push(gopIdx(dir > 0 ? keepLo : keepHi));
        var seen = {};
        for (var i = 0; i < order.length; i++) {
          if (seen[order[i]]) continue;
          seen[order[i]] = 1;
          if (!queueGop(order[i])) break;
        }
        render();
      }
      function fallbackToVideo() {
        try { decoder.close(); } catch (e) {}
        try { cache.forEach(function (t) { gl.deleteTexture(t); }); freeTex.forEach(function (t) { gl.deleteTexture(t); }); } catch (e) {}
        cache.clear(); freeTex = [];
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        video.style.visibility = '';
        cv = null;
        root.dataset.hdStatus = 'ready';
        seekVideo(displayProgress, true);
      }

      return VideoDecoder.isConfigSupported(config).then(function (sup) {
        if (!sup || !sup.supported || destroyed) throw new Error('nicht unterstützt');
        decoder.configure(config);
        media.appendChild(canvas);
        cv = { fp: clamp(displayProgress, 0, 1) * (N - 1), dir: 1, dirty: true, lastKey: '', set: function (p) {
          var fp = clamp(p, 0, 1) * (N - 1), now = performance.now();
          if (Math.abs(fp - this.fp) > 0.0005) this.dir = fp > this.fp ? 1 : -1;
          var dtS = Math.max(0.008, (now - lastSetAt) / 1000);
          speed = speed * 0.8 + (Math.abs(fp - lastSetFp) / dtS) * 0.2;
          lastSetAt = now; lastSetFp = fp;
          this.fp = fp; kick();
          /* Stillstand: Tempo zurücksetzen und alle Einzelbilder an der Stelle nachladen */
          clearTimeout(settleT);
          settleT = setTimeout(function () { speed = 0; kick(); }, 150);
        }, resize: resize, stats: function () { return { cache: cache.size, queued: queued.size, pending: pendingChunks, queue: decoder.decodeQueueSize, drawn: drawn, key: cv.lastKey, speed: Math.round(speed), stride: stride(), resets: resets, gl: gl instanceof (window.WebGL2RenderingContext || Object) ? 2 : 1, fps: mv.fps, frames: N, gops: KEYS.length }; } };
        root.__hdCv = cv;
        resize();
        lastSetFp = cv.fp;
        kick();
        window.addEventListener('resize', function () { if (cv) { resize(); cv.dirty = true; render(); } }, { passive: true });
      });
    }

    function loadWholeVideo() {
      if (destroyed || !window.fetch || !('VideoDecoder' in window) || !('EncodedVideoChunk' in window)) return;
      var source = video.querySelector('source');
      var src = (source && source.src) || video.currentSrc;
      if (!src) return;
      root.dataset.hdStatus = 'loading-full';
      loadingFull = true;
      var stage = root.querySelector('.hd-scroll-final__stage') || root;
      bar = document.createElement('div');
      bar.setAttribute('aria-hidden', 'true');
      bar.style.cssText = 'position:absolute;left:0;bottom:0;height:2px;width:100%;z-index:4;transform-origin:0 50%;transform:scaleX(0);background:linear-gradient(90deg,rgba(217,180,90,0),#d9b45a 40%,#f3dc9a);transition:transform .2s linear,opacity .5s ease;pointer-events:none';
      stage.appendChild(bar);
      function fail() {
        loadingFull = false;
        if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
        video.preload = 'auto';
        root.dataset.hdStatus = ready ? 'ready' : root.dataset.hdStatus;
        seekVideo(displayProgress, true);
      }
      fetch(src, { mode: 'cors', credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          var total = Number(r.headers.get('content-length')) || 0;
          if (!r.body || !r.body.getReader || !total) return r.arrayBuffer();
          var reader = r.body.getReader(), out = new Uint8Array(total), got = 0;
          return (function pump() {
            return reader.read().then(function (res) {
              if (res.done) return out.buffer;
              if (got + res.value.length > out.length) { var bigger = new Uint8Array(got + res.value.length); bigger.set(out.subarray(0, got)); out = bigger; }
              out.set(res.value, got); got += res.value.length;
              if (bar) bar.style.transform = 'scaleX(' + Math.min(1, got / total).toFixed(3) + ')';
              return pump();
            });
          })().then(function (buf) { return got === total ? buf : out.buffer.slice(0, got); });
        })
        .then(function (buf) { if (!destroyed) return startCanvasMode(buf); })
        .catch(fail);
    }

    /* ---------- gemeinsamer Takt ---------- */
    function tick(now) {
      if (destroyed) return;
      var dt = Math.min(0.05, Math.max(0.001, (now - lastTick) / 1000));
      lastTick = now;
      /* kritisch gedämpfte Feder in zwei Halbschritten (stabil auch bei kurzen Rucklern) */
      for (var h = 0; h < 2; h++) {
        var sdt = dt / 2;
        var acc = OMEGA * OMEGA * (targetProgress - displayProgress) - 2 * OMEGA * vel;
        vel += acc * sdt;
        displayProgress += vel * sdt;
      }
      if (Math.abs(targetProgress - displayProgress) < 0.00002 && Math.abs(vel) < 0.0004) { displayProgress = targetProgress; vel = 0; }

      if (Math.abs(displayProgress - lastProgress) > 0.000005) {
        updateUi(displayProgress);
        if (cv) cv.set(displayProgress); else seekVideo(displayProgress, false);
        lastProgress = displayProgress;
      }
      if (displayProgress !== targetProgress || now - lastScrollAt < 200 || pendingFrame >= 0) raf = requestAnimationFrame(tick);
      else raf = 0;
    }

    function scheduleFromScroll() {
      targetProgress = rawProgress();
      lastScrollAt = performance.now();
      if (!raf) { lastTick = performance.now(); raf = requestAnimationFrame(tick); }
    }

    function markReady() {
      if (ready) return;
      duration = Number(video.duration) || 30;
      ready = true;
      if (!cv && root.dataset.hdStatus !== 'loading-full') root.dataset.hdStatus = 'ready';
      root.classList.add('is-video-ready');
      targetProgress = displayProgress = rawProgress();
      updateUi(displayProgress);
      if (!cv) seekVideo(displayProgress, true);
      try { video.pause(); } catch (e) {}
    }

    function onCanShowFrame() {
      root.classList.add('has-video-frame');
      if (poster) poster.setAttribute('aria-hidden', 'true');
    }

    if (staticMode) {
      root.dataset.hdStatus = 'static';
      updateUi(0);
      return;
    }

    /* ---------- Handy: Video spielt von selbst ab (nach der Logo-Drehung), Texte laufen mit ---------- */
    if (mobile) {
      root.classList.add('is-autoplay');
      root.dataset.hdStatus = 'autoplay';
      video.muted = true; video.playsInline = true; video.loop = false;
      video.setAttribute('muted', ''); video.setAttribute('playsinline', '');
      video.preload = 'auto';
      try { video.load(); } catch (e) {}
      var apGo = false, apInView = true, apRaf = 0;
      function apFrame() {
        apRaf = 0;
        var d = video.duration || duration;
        updateUi(clamp(video.currentTime / d, 0, 1));
        root.classList.toggle('is-scrolled', window.scrollY > 40);
        if (!video.paused && !video.ended) apRaf = requestAnimationFrame(apFrame);
      }
      function apLoop() { if (!apRaf) apRaf = requestAnimationFrame(apFrame); }
      function apPlay() {
        if (!apGo || !apInView || video.ended || !video.paused) return;
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {}); /* z. B. Stromsparmodus: dann bleibt das Startbild stehen */
      }
      function apStart() { if (apGo) return; apGo = true; apPlay(); }
      video.addEventListener('playing', function () { root.classList.add('has-video-frame'); apLoop(); });
      video.addEventListener('seeked', apLoop);
      video.addEventListener('ended', function () { updateUi(1); root.dataset.hdStatus = 'ended'; });
      var apLogo = root.querySelector('[data-hd-logo3d-live]');
      if (!apLogo || apLogo.getAttribute('data-spun')) apStart();
      else { apLogo.addEventListener('hd:logo-spun', apStart, { once: true }); setTimeout(apStart, 4500); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          apInView = en[0].isIntersecting;
          if (!apInView) { if (!video.paused) video.pause(); } else apPlay();
        }, { threshold: 0.25 }).observe(root);
      }
      updateUi(0);
      window.addEventListener('scroll', function () { root.classList.toggle('is-scrolled', window.scrollY > 40); }, { passive: true });
      return;
    }

    video.muted = true;
    video.playsInline = true;
    /* Mit eigenem Decoder lädt das Video nur einmal komplett – das Video-Element holt dann nur die Eckdaten */
    video.preload = ('VideoDecoder' in window) ? 'metadata' : 'auto';
    video.pause();
    if (video.readyState >= 1) markReady(); else video.addEventListener('loadedmetadata', markReady, { once: true });
    if (video.readyState >= 2) onCanShowFrame();
    else {
      video.addEventListener('loadeddata', onCanShowFrame, { once: true });
      video.addEventListener('seeked', onCanShowFrame, { once: true });
    }
    video.addEventListener('seeked', onSeeked);

    /* Komplettes Video sofort im Hintergrund laden */
    loadWholeVideo();

    /* Am Seitenanfang erst scrollen lassen, wenn sich das Logo einmal gedreht hat –
       in der Zeit lädt das Video vor. Nie länger als 10 Sekunden. */
    (function heroLock() {
      var html = document.documentElement;
      var logo = root.querySelector('[data-hd-logo3d-live]');
      if (!logo || html.classList.contains('shopify-design-mode') || location.hash) return;
      function maybeStart() {
        if (window.scrollY > 4 || rawProgress() > 0.005 || logo.getAttribute('data-spun')) return;
        /* Im Hintergrund-Tab dreht sich das Logo noch nicht – Sperre erst starten, wenn der Tab sichtbar wird */
        if (document.hidden) {
          document.addEventListener('visibilitychange', function onVis() {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVis);
            maybeStart();
          });
          return;
        }
        start();
      }
      /* Nach Neuladen/Zurück stellt der Browser evtl. die alte Position wieder her – erst danach entscheiden */
      var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (nav && (nav.type === 'reload' || nav.type === 'back_forward') && document.readyState !== 'complete') {
        window.addEventListener('load', function () { setTimeout(maybeStart, 0); }, { once: true });
      } else maybeStart();
      function start() {
      var t0 = performance.now(), logoAt = 0, iv = 0;
      var KEYS = { 32: 1, 33: 1, 34: 1, 35: 1, 36: 1, 38: 1, 40: 1 };
      function block(e) { e.preventDefault(); }
      function blockKey(e) {
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        if (KEYS[e.keyCode]) e.preventDefault();
      }
      function hold() { if (window.scrollY !== 0) window.scrollTo(0, 0); }
      function videoReady() { return root.dataset.hdStatus === 'canvas' || (!loadingFull && ready); }
      function onSpun() { if (!logoAt) logoAt = performance.now(); check(); }
      function release() {
        clearInterval(iv);
        window.removeEventListener('wheel', block, { capture: true });
        window.removeEventListener('touchmove', block, { capture: true });
        window.removeEventListener('keydown', blockKey, { capture: true });
        window.removeEventListener('scroll', hold);
        logo.removeEventListener('hd:logo-spun', onSpun);
        html.classList.remove('hd-hero-lock');
        root.classList.remove('is-locked');
        root.__hdUnlocked = performance.now();
      }
      function check() {
        var now = performance.now();
        if (now - t0 > 10000) return release();                /* Notbremse */
        if (!logoAt && now - t0 > 6000) logoAt = now;          /* Logo hat sich nicht gedreht (z. B. 3D nicht verfügbar) */
        if (!logoAt) return;
        if (videoReady() || now - logoAt > 2500) release();     /* Video bereit – oder höchstens 2,5 s nach der Drehung */
      }
      html.classList.add('hd-hero-lock');
      root.classList.add('is-locked');
      window.addEventListener('wheel', block, { passive: false, capture: true });
      window.addEventListener('touchmove', block, { passive: false, capture: true });
      window.addEventListener('keydown', blockKey, { capture: true });
      window.addEventListener('scroll', hold, { passive: true });
      if (logo.getAttribute('data-spun')) logoAt = t0;
      logo.addEventListener('hd:logo-spun', onSpun);
      iv = setInterval(check, 100);
      }
    })();

    targetProgress = displayProgress = rawProgress();
    updateUi(displayProgress);
    window.addEventListener('scroll', scheduleFromScroll, { passive: true });
    window.addEventListener('resize', scheduleFromScroll, { passive: true });

    root.__hdCleanup = function () {
      destroyed = true;
      window.removeEventListener('scroll', scheduleFromScroll);
      window.removeEventListener('resize', scheduleFromScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-hd-scroll-final]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-hd-scroll-final]') : null;
    if (root && root.__hdCleanup) root.__hdCleanup();
  });
})();
